var _style, _path, _polygon, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgContinuousFeedbackSentFeedback(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 570 511.7",
    style: {
      enableBackground: "new 0 0 570 511.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#3F3D56;}\n\t.st1{fill:#E6E6E6;}\n\t.st2{fill:#48B3D3;}\n\t.st3{fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M565,195.7c-0.2,0-0.4-0.1-0.6-0.2L287.9,2.9c-1.7-1.2-4-1.2-5.7,0L7.6,195.5c-0.5,0.3-1.1,0.2-1.4-0.2 c-0.3-0.5-0.2-1.1,0.2-1.4L281,1.3c2.4-1.7,5.6-1.7,8,0l276.6,192.6c0.5,0.3,0.6,0.9,0.2,1.4C565.6,195.5,565.3,195.7,565,195.7 L565,195.7z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "23.3,202.5 285.3,8.3 549.3,216.3 298.8,364.8 162.8,333.8 "
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M174.3,456.5H44.8c-3.3,0-6.1-2.7-6.1-6c0-3.3,2.7-6.1,6-6.1c0,0,0,0,0,0h129.4c3.3,0,6.1,2.7,6.1,6 C180.3,453.8,177.6,456.5,174.3,456.5C174.3,456.5,174.3,456.5,174.3,456.5z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M91.3,430.5H44.8c-3.3,0-6.1-2.7-6.1-6c0-3.3,2.7-6.1,6-6.1c0,0,0,0,0,0h46.4c3.3,0,6.1,2.7,6.1,6 C97.3,427.8,94.6,430.5,91.3,430.5C91.3,430.5,91.3,430.5,91.3,430.5z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M289,310.7c-1,0-2-0.2-2.9-0.6l-161.6-67V33.2c0-3.9,3.1-7,7-7h310c3.9,0,7,3.1,7,7v210l-0.3,0.1l-156.3,66.7 C291,310.5,290,310.7,289,310.7z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M289,311.2c-1,0-2.1-0.2-3.1-0.6L124,243.4V33.2c0-4.1,3.4-7.5,7.5-7.5h310c4.1,0,7.5,3.4,7.5,7.5v210.4 l-156.9,67C291.1,310.9,290,311.2,289,311.2z M126,242l160.7,66.7c1.5,0.6,3.2,0.6,4.7,0L447,242.2v-209c0-3-2.5-5.5-5.5-5.5h-310 c-3,0-5.5,2.5-5.5,5.5L126,242z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M563,193.7h-0.2l-114.8,49l-157.1,67.1c-1.2,0.5-2.6,0.5-3.9,0l-162-67.2L7.4,193.8l-0.2-0.1H7 c-3.9,0-7,3.1-7,7v304c0,3.9,3.1,7,7,7h556c3.9,0,7-3.1,7-7v-304C570,196.8,566.9,193.7,563,193.7z M568,504.7c0,2.8-2.2,5-5,5H7 c-2.8,0-5-2.2-5-5v-304c0-2.7,2.1-4.9,4.8-5l118.2,49l161.3,66.9c1.7,0.7,3.7,0.7,5.4,0L448,244.9l115.2-49.2c2.7,0.1,4.8,2.3,4.8,5 V504.7z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M287.3,251.1c-6,0-11.8-1.9-16.5-5.5l-0.3-0.2l-62.3-47.7c-12.1-9.3-14.4-26.7-5.1-38.8s26.7-14.4,38.8-5.1 l40.4,30.9l95.4-124.4c9.3-12.1,26.7-14.4,38.8-5.1c0,0,0,0,0,0l-0.6,0.8l0.6-0.8c12.1,9.3,14.4,26.7,5.1,38.8L309.4,240.3 C304.1,247.2,296,251.2,287.3,251.1z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContinuousFeedbackSentFeedback);
export default __webpack_public_path__ + "static/media/continuous-feedback-sent-feedback.db5043dc22a33502eb31f25e321e9742.svg";
export { ForwardRef as ReactComponent };